module.exports = __webpack_public_path__ + "img/rate3.7cb2be2f.svg";